"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrices = exports.getOptionValue = exports.addToCart = exports.getProductData = void 0;
var shop_data_1 = require("../shopify-graphql/shop-data");
var getProductData = function (_a) {
    var shopData = _a.shopData, optionIndex = _a.optionIndex, purchaseTypeIndex = _a.purchaseTypeIndex, quantityIndex = _a.quantityIndex, singleProductBundle = _a.singleProductBundle;
    return __awaiter(void 0, void 0, void 0, function () {
        var product_1, variant_1, productData_1, productHandle, product, variant, variantId, sellingPlan, productData;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (singleProductBundle) {
                        product_1 = singleProductBundle;
                        variant_1 = product_1.variants.nodes[quantityIndex];
                        productData_1 = {
                            items: [
                                {
                                    id: variant_1.id.split('/')[4],
                                    quantity: 1,
                                    selling_plan: undefined,
                                },
                            ],
                        };
                        return [2 /*return*/, { data: productData_1, product: product_1, variant: variant_1 }];
                    }
                    productHandle = (_b = shopData === null || shopData === void 0 ? void 0 : shopData.options.references.nodes[optionIndex].purchaseTypes) === null || _b === void 0 ? void 0 : _b.references.nodes[purchaseTypeIndex].products.references.nodes[quantityIndex].handle;
                    return [4 /*yield*/, (0, shop_data_1.getShopProductData)(productHandle)];
                case 1:
                    product = _d.sent();
                    variant = product === null || product === void 0 ? void 0 : product.variants.nodes[0];
                    variantId = variant === null || variant === void 0 ? void 0 : variant.id.split('/')[4];
                    sellingPlan = (_c = variant === null || variant === void 0 ? void 0 : variant.sellingPlanAllocations.nodes[0]) === null || _c === void 0 ? void 0 : _c.sellingPlan.id.split('/')[4];
                    productData = {
                        items: [
                            {
                                id: variantId,
                                quantity: 1,
                                selling_plan: sellingPlan,
                            },
                        ],
                    };
                    return [2 /*return*/, { data: productData, product: product, variant: variant }];
            }
        });
    });
};
exports.getProductData = getProductData;
var addToCart = function (productData) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(productData),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                console.error('Error:', err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.addToCart = addToCart;
var getOptionValue = function (optionData) {
    return optionData.option.value.replace(/\[.*?\]/g, '').replace(/[^A-Za-z]/g, '');
};
exports.getOptionValue = getOptionValue;
var getPrices = function (_a) {
    var _b;
    var options = _a.options, optionIndex = _a.optionIndex, purchaseTypeIndex = _a.purchaseTypeIndex, quantityIndex = _a.quantityIndex, singleProductBundle = _a.singleProductBundle;
    if (singleProductBundle) {
        return {
            compareAtPrice: singleProductBundle.variants.nodes[quantityIndex].compareAtPrice,
            price: singleProductBundle.variants.nodes[quantityIndex].price,
        };
    }
    var optionNode = (_b = options[optionIndex].purchaseTypes) === null || _b === void 0 ? void 0 : _b.references.nodes[purchaseTypeIndex].products.references.nodes[quantityIndex];
    return {
        compareAtPrice: optionNode === null || optionNode === void 0 ? void 0 : optionNode.compareAtPriceRange.minVariantPrice,
        price: optionNode === null || optionNode === void 0 ? void 0 : optionNode.priceRange.minVariantPrice,
    };
};
exports.getPrices = getPrices;
